import ReactModal from "react-modal";
import styled from "styled-components";

export const Container = styled.form`
overflow-y: auto !important;
height: 90%;

.add-input{
    display: flex;
    gap: 1rem;
}

.input-container{
    display: flex;
    gap: 1rem;
    align-items: center;
}
.popup-title{
    width: 100%;
    text-align: center; 
    margin-top: 4rem;

    h1{
        font-weight: 600;
    }
}
    .add-ingredient-container{
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 1.5rem;
    width: 100%;
    padding: 0 5rem;
    }
    .input{
          height: 5.2rem;
            background-color: var(--light-gray);
            border-radius: 5px;
            outline-style: none;
            border: none;
               @media (max-width: 768px) {
             margin-top: 2rem;
            }
    }
`


export const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border-radius: 3rem;
  padding: 1rem;
  background: white;
  overflow: auto;
  outline: none;

  @media (max-width: 425px) {
    width: 90%;
    padding: 1.5rem;
  }
`;